import React from 'react';
import { Link } from "react-router-dom";
import './Footer.css'; // ייבוא קובץ העיצוב החדש
import { Routes, Route } from "react-router-dom";




export default function Footer() {
  return (
    <footer className="site-footer" dir="rtl">
      {/* אזור הניווט הראשי */}
      <div className="footer-container">
        
        {/* עמודה 1: ניווט מהיר */}
    <div className="footer-column">
  <h3 className="footer-title">ניווט מהיר</h3>
  <ul className="footer-inline-list">

    <li><Link to="/"> עמוד הבית</Link> </li>
    <li><Link to="/ServicesPage">השירותים שלנו</Link></li>
    <li><Link to="/about">אודות</Link></li>
    <li><Link to="/Building_Transportation"> הובלת מבנים</Link></li>
        <li><Link to="/Moving_with_a_lifting_crane"> הובלת עם מנוף הרמה</Link></li>
    <li><Link to="/WorksGallery">גלריית עבודות</Link></li>
    <li><Link to="/ContactSection2">צור קשר</Link></li>
    <li><Link to="/Privacy_Policy">מדיניות פרטיות</Link></li>

  </ul>
</div>
        {/* עמודה 2: השירותים שלנו */}
   <div className="footer-column">
  <h3 className="footer-title">השירותים שלנו</h3>
  <ul className="footer-inline-list">

    <li><Link to="/Relocation_of_buildings"> העברת מבנים</Link></li>
    <li><Link to="/Lifting_Buildings"> הרמת מבנים</Link></li>
    <li><Link to="/BuildingRehabilitation"> הובלת קרוואנים</Link></li>
    <li><Link to="/Transportation_of_protective_equipment_and_mobile_safe_room"> הובלת מיגונית וממ"ד נייד</Link></li>
    <li><Link to="/Transportation_of_building_materials"> הובלת חומרי בניין</Link></li>
    <li><Link to="/Transporting_wood"> הובלת עצים </Link></li>
    <li><Link to="/Transporting_heavy_equipment"> הובלת ציוד כבד </Link></li>
    <li><Link to="/Container_Transportation">  הובלת מכולות </Link></li>

  </ul>
</div>

        {/* עמודה 3: שירותים נוספים */}
   <div className="footer-column">
  <h3 className="footer-title">שירותים נוספים</h3>
  <ul className="footer-inline-list">

    <li><Link to="/Basket_crane_rental"> השכרת מנוף סל</Link></li>
    <li><Link to="/Crane_Rental1"> השכרת מנוף זרוע</Link></li>
    <li><Link to="/Hourly_Lifting_Basket_Rental"> השכרת סל הרמה לפי שעה</Link></li>
    <li><Link to="/Renting_a_basket_crane_for_lifting_a_person"> השכרת מנוף סל להרמת אדם</Link></li>
    <li><Link to="/Crane_work_nationwide"> עבודות מנוף בפריסה ארצית </Link></li>


  </ul>
</div>

        {/* עמודה 4: פרטי קשר */}
        <div className="footer-column contact-column">
          <div><strong>כתובת:</strong>העוגן 9, יבנה</div>
          <div><strong>טלפון:</strong> 050-6615262</div>
          <div><a href="mailto:itumimbgvahim@gmail.com">Netzerhovalot@gmail.com</a></div>
  
        </div>

      </div>

      {/* אזור זכויות יוצרים תחתון */}
      <div className="footer-bottom">
        <div className="footer-bottom-container">
          <div>© 2026 כל הזכויות שמורות לנצר הובלות ומנופים בע"מ - הובלות ומנופים</div>
          <div className="footer-logo">
  <a href="https://siteb2b.co.il/" target="_blank" rel="noopener noreferrer">
    <img src="/logooo.png" alt="לוגו" />
  </a>
</div>
        </div>
      </div>
    </footer>
  );
}
